import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/_partials/BasicUserName';
import s from './MoreByAuthor.scss';
export var MoreByAuthor = function (_a) {
    var i18nSubKey = _a.i18nSubKey, author = _a.author, className = _a.className, linkToProfileSection = _a.linkToProfileSection;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(UserLink, { user: author, className: s['by-author'], linkTo: linkToProfileSection },
            React.createElement(Trans, { i18nKey: "sidebar.blockTitle." + i18nSubKey },
                "More things by ",
                React.createElement(BasicUserName, { user: author })))));
};
MoreByAuthor.displayName = 'MoreByAuthor';
export default MoreByAuthor;
//# sourceMappingURL=MoreByAuthor.js.map